var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5C2 8.567 6.08172 7 10.5 7C14.9183 7 19 8.567 19 10.5V18.5C19 20.433 14.9183 22 10.5 22C6.08172 22 2 20.433 2 18.5V17.7582C3.33534 18.9631 5.05467 19.7182 6.91191 19.8509L8.25406 19.9467C8.65714 19.9755 9 19.6563 9 19.2522V15.6049C9 15.2578 8.74477 14.9635 8.40115 14.9144L6.69574 14.6708C4.84285 14.4061 3.18864 13.482 2 12.1213V10.5ZM10.5 13C14.1386 13 17.5 11.8807 17.5 10.5C17.5 9.11929 14.1386 8 10.5 8C6.86142 8 3.5 9.11929 3.5 10.5C3.5 11.8807 6.86142 13 10.5 13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.6536C21.4367 11.5273 22 10.0794 22 8.5C22 4.91015 19.0899 2 15.5 2C12.9863 2 10.8059 3.42687 9.72449 5.51485C9.98202 5.505 10.2407 5.5 10.5 5.5C12.8654 5.5 15.186 5.91637 16.9672 6.63372C17.8534 6.99063 18.6813 7.45204 19.313 8.0376C19.9426 8.62128 20.5 9.45162 20.5 10.5V12.6536Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeup2);
export default __webpack_public_path__ + "static/media/makeup-2.ff5b3d01cf9a9d1e95806f5ab77f4626.svg";
export { ForwardRef as ReactComponent };